const videoElementOrig = $('.js-video-player');
let playerBase;
let isZoomed = false;
let isOverlayed = false;
let isFrostlined = false;
let isSeeking = false;
let watchAgainCountdownIntervalId = null;
let currentSegment = 0;
let count = 0;
let isPlayerCanPlay = false;
let isZoomCanPlay = false;

/* need to be placed here so it be triggered at the right moment */
$(document).ready(function () {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('scrollToVideoPlayer') === 'true') {
        document
            .querySelector('.js-video-player-wrapper')
            .scrollIntoView({ behavior: 'auto', block: 'start' });
    }
});

function initPlayerBase() {
    playerBase = videojs('videoPlayer', playerOptions);
}

function reinitializePlayerBaseControls() {
    playerBase.controls(false);
    playerBase.controls(true);
    playerBase.controlBar.show();
}

runIfElementExist(initPlayerBase, '.video-js');

function videoPlayer() {
    $('.js-video-play-next-btn').attr(
        'href',
        nextVideosData[0].pageLink +
            (nextVideosData[0].pageLink.includes('?') ? '&' : '?') +
            'scrollToVideoPlayer=true'
    );

    playerBase.on('canplaythrough', function () {
        isPlayerCanPlay = true;
        $(document).trigger('playerCanPlayEvent');
    });

    playerBase.on('play', function () {
        if (!isOverlayed && !isFrostlined) {
            zoomPlayer.paused && zoomPlayer.play();
        }

        if (isOverlayed) {
            playerOverlay.play();
        }
        reinitializePlayerBaseControls();
    });

    playerBase.on('ratechange', function () {
        if (!isOverlayed && !isFrostlined) {
            zoomPlayer.playbackRate = playerBase.playbackRate();
        }

        if (isOverlayed) {
            playerOverlay.playbackRate = playerBase.playbackRate();
        }

        reinitializePlayerBaseControls();
    });

    playerBase.on('timeupdate', function () {
        if (isOverlayed && !isSeeking) {
            adjustSegments(
                mainVideoSegmentsData,
                overlayVideoData[videoOverlayIndex].segments,
                playerBase,
                playerOverlay
            );
        }

        if (isFrostlined) {
            adjustFrostlines(this.currentTime());
        }

        reinitializePlayerBaseControls();
    });

    playerBase.on('seeking', function () {
        isSeeking = true;
    });

    playerBase.on('seeked', function () {
        isSeeking = false;
        count = count + 1;

        if (!isOverlayed && !isFrostlined) {
            zoomPlayer.currentTime = playerBase.currentTime();
        }

        if (isOverlayed) {
            playerOverlay.currentTime = playerBase.currentTime();
        }

        reinitializePlayerBaseControls();
    });

    playerBase.on('pause', function () {
        if (!isOverlayed && !isFrostlined) {
            !zoomPlayer.paused && zoomPlayer.pause();
        }

        if (isOverlayed && !isPlayerBaseEnded) {
            playerOverlay.pause();
        }
        reinitializePlayerBaseControls();
    });

    playerBase.on('ended', function () {
        !isOverlayed && startCountdown();

        if (isOverlayed) {
            isPlayerBaseEnded = true;

            if (isPlayerOverlayEnded && isPlayerBaseEnded) {
                startCountdown();
            }
        }

        reinitializePlayerBaseControls();
    });

    const videoPlayerElement = document.querySelector('.js-video-player');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    document.addEventListener('keydown', handleKeydown);
                } else {
                    document.removeEventListener('keydown', handleKeydown);
                }
            });
        },
        { threshold: 0.5 }
    );

    observer.observe(videoPlayerElement);

    function handleKeydown(event) {
        switch (event.code) {
            case 'Space':
                event.preventDefault();

                if (playerBase.paused()) {
                    playerBase.play();
                } else {
                    playerBase.pause();
                }
                break;
            case 'ArrowRight':
                playerBase.currentTime(playerBase.currentTime() + 1 / 30); // Move forward
                break;
            case 'ArrowLeft':
                playerBase.currentTime(playerBase.currentTime() - 1 / 30); // Move backward
                break;
        }
    }

    // custom behavior for touch devices
    document
        .querySelector('.js-video-player .vjs-tech')
        .addEventListener('touchstart', function () {
            if (playerBase.paused()) {
                playerBase.play();
            } else {
                playerBase.pause();
            }
        });
}

runIfElementExist(videoPlayer, '.video-js');
